import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {
  SR_QUEST_TEST_ID,
  SearchResultQuestionnaireWidgetProps,
} from './SearchResultQuestionnaireWidget';

export const SearchResultsHelpful: React.FC<
  Pick<
    SearchResultQuestionnaireWidgetProps,
    'onThumbsUpClick' | 'onThumbsDownClick'
  > & {className?: string; dataTestId: string}
> = ({className, dataTestId, onThumbsUpClick, onThumbsDownClick}) => {
  const {t} = useTranslation();
  return (
    <Wrapper className={className} data-testid={dataTestId}>
      {t('Search results helpful?')}
      <ThumbsUp
        data-testid={`${SR_QUEST_TEST_ID}-thumbsUp`}
        onClick={onThumbsUpClick}
      >
        👍
      </ThumbsUp>
      <ThumbsDown
        data-testid={`${SR_QUEST_TEST_ID}-thumbsDown`}
        onClick={onThumbsDownClick}
      >
        👎
      </ThumbsDown>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 48px;
  border-radius: 25px;
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
`;

const thumbsStyle = css`
  display: flex;
  align-items: center;
  height: 100%;
  font-size: ${FONT_SIZES.px24};
  margin: 0 10px;
  cursor: pointer;
`;

const ThumbsUp = styled.div`
  ${thumbsStyle}
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: -11px;
    background-color: ${COLORS.Grey5};
    width: 1px;
    height: 100%;
  }
`;

const ThumbsDown = styled.div`
  ${thumbsStyle}
  margin-right: 0;
`;
